// modules are defined as an array
// [ module function, map of requires ]
//
// map of requires is short require name -> numeric require
//
// anything defined in a previous bundle is accessed via the
// orig method which is the require for previous bundles

(function (modules, entry, mainEntry, parcelRequireName, globalName) {
  /* eslint-disable no-undef */
  var globalObject =
    typeof globalThis !== 'undefined'
      ? globalThis
      : typeof self !== 'undefined'
      ? self
      : typeof window !== 'undefined'
      ? window
      : typeof global !== 'undefined'
      ? global
      : {};
  /* eslint-enable no-undef */

  // Save the require from previous bundle to this closure if any
  var previousRequire =
    typeof globalObject[parcelRequireName] === 'function' &&
    globalObject[parcelRequireName];

  var cache = previousRequire.cache || {};
  // Do not use `require` to prevent Webpack from trying to bundle this call
  var nodeRequire =
    typeof module !== 'undefined' &&
    typeof module.require === 'function' &&
    module.require.bind(module);

  function newRequire(name, jumped) {
    if (!cache[name]) {
      if (!modules[name]) {
        // if we cannot find the module within our internal map or
        // cache jump to the current global require ie. the last bundle
        // that was added to the page.
        var currentRequire =
          typeof globalObject[parcelRequireName] === 'function' &&
          globalObject[parcelRequireName];
        if (!jumped && currentRequire) {
          return currentRequire(name, true);
        }

        // If there are other bundles on this page the require from the
        // previous one is saved to 'previousRequire'. Repeat this as
        // many times as there are bundles until the module is found or
        // we exhaust the require chain.
        if (previousRequire) {
          return previousRequire(name, true);
        }

        // Try the node require function if it exists.
        if (nodeRequire && typeof name === 'string') {
          return nodeRequire(name);
        }

        var err = new Error("Cannot find module '" + name + "'");
        err.code = 'MODULE_NOT_FOUND';
        throw err;
      }

      localRequire.resolve = resolve;
      localRequire.cache = {};

      var module = (cache[name] = new newRequire.Module(name));

      modules[name][0].call(
        module.exports,
        localRequire,
        module,
        module.exports,
        this
      );
    }

    return cache[name].exports;

    function localRequire(x) {
      var res = localRequire.resolve(x);
      return res === false ? {} : newRequire(res);
    }

    function resolve(x) {
      var id = modules[name][1][x];
      return id != null ? id : x;
    }
  }

  function Module(moduleName) {
    this.id = moduleName;
    this.bundle = newRequire;
    this.exports = {};
  }

  newRequire.isParcelRequire = true;
  newRequire.Module = Module;
  newRequire.modules = modules;
  newRequire.cache = cache;
  newRequire.parent = previousRequire;
  newRequire.register = function (id, exports) {
    modules[id] = [
      function (require, module) {
        module.exports = exports;
      },
      {},
    ];
  };

  Object.defineProperty(newRequire, 'root', {
    get: function () {
      return globalObject[parcelRequireName];
    },
  });

  globalObject[parcelRequireName] = newRequire;

  for (var i = 0; i < entry.length; i++) {
    newRequire(entry[i]);
  }

  if (mainEntry) {
    // Expose entry point to Node, AMD or browser globals
    // Based on https://github.com/ForbesLindesay/umd/blob/master/template.js
    var mainExports = newRequire(mainEntry);

    // CommonJS
    if (typeof exports === 'object' && typeof module !== 'undefined') {
      module.exports = mainExports;

      // RequireJS
    } else if (typeof define === 'function' && define.amd) {
      define(function () {
        return mainExports;
      });

      // <script>
    } else if (globalName) {
      this[globalName] = mainExports;
    }
  }
})({"eGfTE":[function(require,module,exports) {
var _defaultJs = require("./_default.js");
var _notificationsJs = require("./notifications.js");
var _translationsJs = require("./translations.js");
var _activitiesJs = require("./activities.js");
const landing = {
    init: async function() {
        // Initialize translations
        await (0, _translationsJs.translations).init();
        // Show page
        (0, _defaultJs.qS)("#page_landing").classList.remove("page-loading");
        // Scroll page if below 800px width (must be shown before)
        if (window.innerWidth < 800) window.scrollTo(0, 215);
        // Initialize notifications and info bar
        (0, _notificationsJs.notifications).init();
        // Track page view
        (0, _activitiesJs.activities).initAndTrackPageview();
    }
};
window.onload = ()=>landing.init();

},{"./_default.js":"cDVrj","./notifications.js":"gCfei","./translations.js":"b4aUR","./activities.js":"5q0h4"}],"gCfei":[function(require,module,exports) {
// Import project modules
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "notifications", ()=>notifications);
var _defaultJs = require("./_default.js");
var _translationsJs = require("./translations.js");
const notifications = {
    STAY_FOR_MS: 4000,
    active: false,
    init: async function() {
        // Activate
        notifications.active = true;
        // Notifications
        (0, _defaultJs.qS)("body").insertAdjacentHTML("beforeend", '<div id="notifications_container" class="notification-container"></div>');
        // Info
        (0, _defaultJs.qS)("body").insertAdjacentHTML("afterbegin", '<div id="info_container" class="info-container"></div>');
        // Check for URL parameters
        notifications.checkForURLParamater();
    },
    showSuccess: function(message) {
        if (!message) message = (0, _translationsJs.translations).getString("app.save_success");
        notifications.show(message, "success", "#notifications_container");
        notifications.easterEgg();
    },
    showError: function(message) {
        if (!message) message = (0, _translationsJs.translations).getString("app.unknown_error");
        notifications.show(message, "error", "#notifications_container", true);
    },
    remove: function(element) {
        // Element could have been removed before
        try {
            if (element.parentElement.innerHTML === "") element.parentElement.style.display = "none";
            element.remove();
        } catch (error) {
            console.log("Element no longer exists");
        }
    },
    show: function(message, type, target, stay) {
        if (!notifications.active) return;
        const targetElement = (0, _defaultJs.qS)(target);
        const div = document.createElement("div");
        div.classList.add(`notification`);
        if (type) div.classList.add(`info-${type}`);
        if (stay) div.classList.add(`notification-stay`);
        // Create the inner text div
        const textDiv = document.createElement("div");
        textDiv.classList.add("text");
        textDiv.textContent = message;
        // Create the close button div
        const closeDiv = document.createElement("div");
        closeDiv.classList.add("close");
        // Add an event listener to remove the parent div when close is clicked
        closeDiv.addEventListener("click", ()=>{
            notifications.remove(div);
        });
        // Append textDiv and closeDiv to the main div
        div.appendChild(textDiv);
        div.appendChild(closeDiv);
        targetElement.appendChild(div);
        targetElement.style.display = "block";
        if (!stay) setTimeout(()=>{
            notifications.remove(div);
        }, notifications.STAY_FOR_MS);
    },
    easterEgg: function() {
        if (!notifications.active) return;
        if (!(0, _defaultJs.isAdmin)) return;
         // Only for pages /admin
        if (Math.random() > .01) return;
         // 1% chance
        const easterEggDiv = document.createElement("div");
        easterEggDiv.classList.add("easter-egg");
        document.body.appendChild(easterEggDiv);
        setTimeout(()=>{
            easterEggDiv.remove();
        }, 5000);
    },
    checkForURLParamater: function() {
        const url = new URL(window.location.href);
        const params = new URLSearchParams(url.search);
        const info = params.has("info") ? decodeURIComponent(params.get("info")) : null;
        if (info) notifications.show(info, params.get(`info_type`) || null, "#info_container", true);
        const notification = params.has("notification") ? decodeURIComponent(params.get("notification")) : null;
        if (notification) notifications.show(notification, params.get(`notification_type`) || null, "#notifications_container");
        // Remove URL parameters
        [
            "info",
            "notification",
            "info_type",
            "notification_type"
        ].forEach((param)=>params.delete(param));
        const newUrl = params.toString() ? `${url.pathname}?${params.toString()}` : url.pathname;
        window.history.replaceState({}, document.title, newUrl);
    }
};
// For all modules available
window.notifications = notifications;

},{"./_default.js":"cDVrj","./translations.js":"b4aUR","@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"5q0h4":[function(require,module,exports) {
// Import project modules
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "activities", ()=>activities);
var _initFirebaseJs = require("./initFirebase.js");
var _defaultJs = require("./_default.js");
const activities = {
    publicId: null,
    name: null,
    activityTypes: {
        pageLoad: "page_load",
        signup: "signup",
        logout: "logout",
        login: "login",
        deleteAccount: "delete_account",
        updatedProfile: "updated_profile",
        errorSeen: "error_seen",
        requestedLoginCode: "requested_login_code",
        sendChatMessage: "send_chat_message"
    },
    initAndTrackPageview: async function() {
        console.log("initAndTrackPageview");
        // Check if activity visitor id is set
        let publicId = localStorage.getItem("publicId");
        // Check url, if url parameter is set and no localStorage is set
        if ((0, _defaultJs.url).parameters.pId) {
            publicIdFromUrl = (0, _defaultJs.url).parameters.pId;
            publicIdFromLocalStorage = localStorage.getItem("publicId") || null;
            //localStorage.setItem('publicId', publicId);
            const getNameFromPublicIdResponse = await (0, _initFirebaseJs.httpsCallable)((0, _initFirebaseJs.functions), "handlePublicIdFromUrl")({
                publicIdFromUrl,
                publicIdFromLocalStorage
            });
            console.log({
                publicIdFromUrl,
                publicIdFromLocalStorage,
                getNameFromPublicIdResponse
            });
            if (getNameFromPublicIdResponse?.data?.success && getNameFromPublicIdResponse?.data?.name) {
                activities.updateName(getNameFromPublicIdResponse.data.name);
                localStorage.setItem("publicId", publicIdFromUrl);
            }
        } else if (!publicId) {
            publicId = (0, _defaultJs.randomHash)(20);
            localStorage.setItem("publicId", publicId);
        }
        // Set visitor id
        activities.publicId = publicId;
        // Set visitor name
        activities.name = localStorage.getItem("name") || `Anonymous ${publicId.substr(0, 2)}`;
        // Log page load
        activities.log(activities.activityTypes.pageLoad, null);
    },
    updateName: function(name) {
        console.log("updateName");
        activities.name = name;
        localStorage.setItem("name", name);
    },
    log: async function(activityType, additionalData) {
        console.log("log");
        const createdAt = new Date().toISOString();
        const publicId = activities.publicId;
        const name = activities.name;
        const userAgent = navigator.userAgent;
        if (!additionalData) additionalData = null;
        else if (additionalData.updates?.email) additionalData.updates.email = "{hiding}";
        try {
            // Push the log data to the Realtime Database
            const activityLogsRef = (0, _initFirebaseJs.dbRef)((0, _initFirebaseJs.database), "activityLogs");
            await (0, _initFirebaseJs.push)(activityLogsRef, {
                createdAt,
                publicId,
                name,
                activityType,
                url: (0, _defaultJs.url).href,
                additionalData,
                userAgent
            });
        } catch (error) {
            console.error("Error logging activity:", error);
        }
    }
};
// For debugging
window.activities = activities;

},{"./initFirebase.js":"ixjFZ","./_default.js":"cDVrj","@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}]},["eGfTE"], "eGfTE", "parcelRequire94c2")

//# sourceMappingURL=index.59b8571d.js.map
